(() => {
  const init = () => {
    document.querySelectorAll('[data-sg-product-addons]').forEach((widget) => {
      if (widget.dataset.initialized === 'true') return;
      widget.dataset.initialized = 'true';

      const form = widget.closest('form[action*="/cart/add"]');
      const checkboxes = [...widget.querySelectorAll('[data-sg-addon-checkbox]')];
      const total = widget.querySelector('[data-sg-addon-total]');
      const error = widget.querySelector('[data-sg-addon-error]');
      if (!form || !checkboxes.length) return;

      const money = (cents) => new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency: 'NZD'
      }).format(cents / 100);

      const updateTotal = () => {
        const cents = checkboxes.reduce((sum, checkbox) => (
          checkbox.checked ? sum + Number(checkbox.dataset.price || 0) : sum
        ), 0);
        total.textContent = money(cents);
      };

      checkboxes.forEach((checkbox) => checkbox.addEventListener('change', updateTotal));

      form.addEventListener('submit', async (event) => {
        const selected = checkboxes.filter((checkbox) => checkbox.checked);
        if (!selected.length) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const variantSelect = form.querySelector('[name="id"]');
        const quantityInput = form.querySelector('[name="quantity"]');
        const button = form.querySelector('.js-atc-btn, [type="submit"]');
        const variantId = Number(variantSelect && variantSelect.value);
        const quantity = Math.max(1, Number(quantityInput && quantityInput.value) || 1);

        if (!variantId || widget.dataset.submitting === 'true') return;
        widget.dataset.submitting = 'true';
        error.hidden = true;
        if (button) button.disabled = true;

        const items = [
          { id: variantId, quantity },
          ...selected.map((checkbox) => ({ id: Number(checkbox.value), quantity: 1 }))
        ];

        try {
          const root = window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root
            : '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'The selected items could not be added.');
          const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
          window.location.href = previewThemeId
            ? `${root}cart?preview_theme_id=${encodeURIComponent(previewThemeId)}`
            : `${root}cart`;
        } catch (requestError) {
          error.textContent = requestError.message || 'Please refresh the page and try again.';
          error.hidden = false;
          widget.dataset.submitting = 'false';
          if (button) button.disabled = false;
        }
      }, true);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
